import { gql, useMutation } from '@apollo/client'
import { User } from '../models'

const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      result {
        givenName
        familyName
        middleName
        nickname
        email
        address
        profile
        gender
        birthdate
        phoneNumber
      }
    }
  }
`
export interface UpdateUserInput {
  id: string
  claims: User
}

export const useUpdateUser = () => {
  const mutation = useMutation<UpdateUserInput>(UPDATE_USER)
  const [updateUser, { loading, error }] = mutation

  return { updateUser, loading, error }
}
